/**
 * English strings for the "Invite user" modal on Company Settings -> Users.
 * Kept out of the main translation file to stay within the size gate.
 */
export const enInviteUser = {
	button: "Invite new user",
	modal: {
		cta: "Invite",
		emailPlaceholder: "Enter email",
		firstNamePlaceholder: "Enter first name",
		lastNamePlaceholder: "Enter last name",
		rolePlaceholder: "Select role",
		title: "Invite user",
		sendingUserLabel: "Sending user",
		seatsUsed: "{{used}} of {{total}} LinkedIn sending seats used.",
		includesEmail: "A sending seat also includes one email address ({{used}} of {{total}} in use).",
		seatsFull:
			"All LinkedIn sending seats are in use. This user can only be invited as a non-sending user until a seat frees up or you add one.",
		seatsFullCta: "Add seats in Billing",
	},
	resend: {
		sent: "Invitation sent to {{email}}.",
		failed: "The invitation could not be sent.",
	},
};
